// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isListCampaignsForReportBuilderResult = objectOf({
  campaigns: arrayOf(
    objectOf({
      id: string,
      name: string,
      tag_names: arrayOf(string),
      campaign_type: string,
      composition_mode: string,
      schedule_type: string,
      message_types: arrayOf(string),
      last_sent: number,
      last_sent_message: number,
      total_sent: number,
      is_draft: boolean,
    })
  ),
});
